import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { PRIMARY, NEUTRAL_LIGHT } from "../../theme/theme";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";

const CallToAction: React.FC = () => {
  return (
    <Box
      sx={{
        py: 10,
        backgroundColor: PRIMARY,
        color: "white",
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h3"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: "white",
              mb: 3,
            }}
          >
            Ready to Start Learning?
          </Typography>
          <Typography
            variant="h6"
            sx={{
              maxWidth: 700,
              mx: "auto",
              mb: 4,
              color: NEUTRAL_LIGHT,
            }}
          >
            Download the MicroLearning App today and transform your learning
            experience with bite-sized lessons that fit your schedule.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                backgroundColor: "white",
                color: PRIMARY,
                "&:hover": {
                  backgroundColor: NEUTRAL_LIGHT,
                },
              }}
              href="https://play.google.com/store/apps/details?id=com.blueberrybytes.microlearningapp"
              target="_blank"
              startIcon={<AndroidIcon />}
            >
              Google Play
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                borderColor: "white",
                color: "white",
                "&:hover": {
                  borderColor: NEUTRAL_LIGHT,
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
              href="https://apps.apple.com/es/app/microlearning-daily/id6744894166"
              target="_blank"
              startIcon={<AppleIcon />}
            >
              App Store
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToAction;
